<template>
  <div class="e-accordions__accordion">
    <button
      @click="toggleOpen()"
      class="e-accordions__accordion-button"
      v-bind:class="{ 'accordion-open': open }"
      aria-expanded="open"
    >
      <div v-if="icon !== ''" class="e-accordions__accordion-icon">
        <img :src="icon" width="25px" height="25px" />
      </div>
      <div class="e-accordions__accordion-title h3">{{ title }}</div>

      <span class="e-accordions__chevron"></span>
    </button>
    <div
      v-show="open"
      class="e-accordions__accordion-content typography"
      v-html="expandedContent"
      :aria-hidden="!open"
    ></div>
  </div>
</template>

<script>
export default {
  name: "Accordion",
  props: {
    title: String,
    icon: String,
    expandedContent: String,
  },
  mounted() {
    this.id = this._uid;
  },
  data() {
    return {
      id: null,
      open: false,
    };
  },
  methods: {
    toggleOpen: function () {
      this.open = !this.open;
    },
  },
};
</script>

<style scoped lang="scss">
// .e-accordions__accordion {
//   padding-bottom: 16px;
//   border-bottom: 1px solid grey;
//   &:not(:last-child) {
//     margin-bottom: 16px;
//   }
// }
// .e-accordions__accordion-button {
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   background-color: $charcoal;
//   padding: 0;
//   margin-bottom: 8px;
//   border: none;
//   width: 100%;
//   cursor: pointer;
// }
// .e-accordions__accordion-title {
//   // @include sub-mobile;
//   margin-right: 10px;
//   text-align: left;
//   color: $white;
//   // @include breakpoint(sm-and-up) {
//   //   @include sub-desktop;
//   //   margin-right: 46px;
//   // }
// }
// .e-accordions__accordion-icon {
//   flex-shrink: 0;
// }
</style>
